import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { EMPTY_VALUE } from '../../../config/consts';
import { GearGridCell } from './GearGridCell';

export const BooleanCell: React.FC<GridCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];
  return (
    <GearGridCell {...props} title="">
      {typeof value === 'boolean' ? value.toString() : EMPTY_VALUE}
    </GearGridCell>
  );
};
